export const CONTEXT_MENU_SEPARATOR_TESTID =
	'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-separator';

export const CONTEXT_MENU_BULK_INDICATOR_TESTID =
	'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-bulk-indicator';
